const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorreo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.84074 29.94584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.02473,8.32763l-8.05109,7.07756a1.68382,1.68382,0,0,1-2.18359,0L8.739,8.32763",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.13263,
    y1: 16.13771,
    x2: 8.73927,
    y2: 20.52383,
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1545,22.73644a2.23535,2.23535,0,0,0,1.52024-2.14361V8.25847a2.32081,2.32081,0,0,0-2.38657-2.2746H8.69348a2.314,2.314,0,0,0-2.37891,2.2746V20.59283a2.31161,2.31161,0,0,0,2.37891,2.2717H15.43",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.48044,21.96515v-1.206s.12349-2.361-2.93207-1.28083",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.48044,21.114s-3.48965-.9762-3.27152,1.0186c.216,1.97521,3.1635.96137,3.27152-.16743,0,0-.11077,1.28768,1.07607,1.28768,1.18691,0,1.87847-1.18433,1.75079-2.51135a4.39509,4.39509,0,1,0-1.77747,4.0303",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorreo);
export default __webpack_public_path__ + "static/media/correo.89bd230a1baf51211e6e285dd98e8b76.svg";
export { ForwardRef as ReactComponent };